import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import getBevName from './get-bev-name';
export default function getNavBarSection(navBarSection) {
  if (!navBarSection) {
    return {};
  }

  var sectionId = navBarSection.id || navBarSection.navigationId || navBarSection.label.toUpperCase().replace(/ /g, '_');
  return {
    id: sectionId,
    containerId: sectionId,
    label: navBarSection.label,
    hasMenu: !!navBarSection.sections,
    bevName: getBevName(navBarSection)
  };
}